import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

export const managerSchema = z.object({
  id: z.string().uuid(),
  clientId: z.string().uuid(),
  name: z.string().min(1),
  firstName: z.string().trim().min(1).optional().nullable(),
  lastName: z.string().trim().min(1).optional().nullable(),
  email: z.string().email().optional().nullable(),
  phone: z.string().trim().min(1).optional().nullable(),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

// Base schema for manager input fields (without refine, so we can use .partial())
const managerInputBaseSchema = z.object({
  clientId: z.string().uuid(),
  name: z.string().optional().or(z.literal('').transform(() => undefined)),
  firstName: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
  lastName: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
  email: z.string().email('Invalid email').optional().or(z.literal('').transform(() => undefined)),
  phone: z.string().trim().min(1).optional().or(z.literal('').transform(() => undefined)),
});

// For creating new managers, at least one name field is required
export const managerInputSchema = managerInputBaseSchema.refine(
  (data) => data.firstName || data.lastName || data.name,
  { message: 'At least one name field (firstName, lastName, or name) is required' }
);

// For updates, all fields are optional (partial update)
export const managerUpdateSchema = managerInputBaseSchema.partial();
